<template>
  <div class="home">
    <div class="record">
      <div v-for="(item,i) in list" :key="i">
        <div v-if="item.user_id == id">
          <div class="record_a">
            <h2>{{nick_name}}</h2>
            <p class="record_time">{{item.time}}</p>
            <p v-if="item.type == '0'" class="record_text">{{item.content}}</p>
            <img v-if="item.type == '1'" class="pic" :src="item.url"  @click="opens(item.url)"/>
            <video v-if="item.type == '2'" class="vid" :src="item.url" controls="controls"></video>
          </div>
        </div>
        <div v-else>
          <div class="record_a blue">
            <h2>{{expert_name}}</h2>
            <p class="record_time">{{item.time}}</p>
            <p v-if="item.type == '0'" class="record_text">{{item.content}}</p>
            <img v-if="item.type == '1'" class="pic" :src="item.url"  @click="opens(item.url)"/>
            <video v-if="item.type == '2'" class="vid" :src="item.url" controls="controls"></video>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { chathistory } from '@/api/resetApi.js'

export default {
  name: 'announcement',
  data(){
    return{
      user_id: '',
      service_order_id: '',
      expert_name: '',
      nick_name: '',
      expert_id: '',
      service_order_id: '',
      id: '',
      list: [],
    }
  },
  created(){
    this.user_id = this.$route.query.user_id
    this.service_order_id = this.$route.query.service_order_id
    this.chathistory()
  },
  methods: {
    async chathistory() {
      let data = new URLSearchParams();
      data.append('user_id',this.user_id)
      data.append('service_order_id',this.service_order_id)
      const res = await chathistory(data)
      console.log(res)
      try {
        if (res.data.code === 1) {
          this.expert_name = res.data.obj.info[0].expert_name;
          this.nick_name = res.data.obj.info[0].nick_name ? res.data.obj.info[0].nick_name : res.data.obj.info[0].user_name;
          this.id = res.data.obj.info[0].user_id;
          this.expert_id = res.data.obj.info[0].expert_id;
          this.list = res.data.obj.con;
        } else {
          this.$createToast({
            txt: res.data.msg,
            type: 'error'
          }).show()
        }
      } catch (error) {}
    }
  }
}
</script>

<style lang="scss">
.home {
  display: flex;
  max-width: 780px;
  margin: 0 auto;
  flex-direction: column;
  position: absolute;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  text-align: left;
  font-size: 12px;
  background: #EBEBEB;
}
.record {
  padding: 10px;
  background: #EBEBEB;
}
.record_a{
	background: #fff;
	width: 230px;
	padding: 20px;
	border-radius: 10px; 
	margin-bottom: 	10px;
	// float: left;
}
.record_a h2{
	color:#2574F6;
	font-size: 14px;
		
}
.record_time{
	margin-top: 10px;
	color:#000;
	margin-bottom: 5px;
}
.record_text{
	line-height: 19px;
	color:#000;
}
.blue{
	background: #1e90ff!important;
	float: right!important;
}
.blue h2{
	color: #eee!important;
}
.pic{
	width: 200px;
}
.vid{
	width: 200px;
}
</style>
